export default __webpack_public_path__ + "static/media/img-ovato-wallet.4df34012.png";